import React, { useState, useEffect } from "react";
import { Text, View, StyleSheet, TouchableOpacity, Platform } from "react-native";

import CloseIcon from "../../common/dialog/CloseIcon";

import {
  getStorageItem,
  getStorageKey,
  navigate,
  setStorageItem,
  openURL,
} from "../../../../helpers/utils.js";

import AppTheme from "../../AppTheme";
import Icons from "../../common/icons/index";
import cardStyles from "../cards/cardStyles";

export default function KnowledgeBaseCard({ controller }) {
  const [showCard, setShowCard] = useState(true);

  useEffect(() => {
    getStorageItem(getStorageKey(controller, "card:knowledge")).then((data) => {
      if (data && !data.show) {
        setShowCard(false);
      }
    });
  }, []);

  const hideCard = () => {
    setShowCard(false);
    setStorageItem(getStorageKey(controller, "card:knowledge"), {
      show: false,
    });
  };

  const seeMore = () => {
    navigate(controller, "rn:knowledge_base");
  };

  const buttons = [
    {
      url: "https://mana.ai/blog/avoid-distractions",
      text: "How to Avoid Distractions",
    },
    {
      url: "https://mana.ai/blog/how-to-set-work-life-boundaries",
      text: "Setting Work-Life Boundaries at Home",
    },
    {
      url: "https://mana.ai/blog/time-management-secret",
      text: "The Power of No",
    },
    {
      url: "https://mana.ai/blog/steps-to-set-goals",
      text: "7 Steps to Successful Goal-Setting",
    },
  ];

  return !showCard ? null : (
    <View style={cardStyles.container}>
      <View style={[cardStyles.card, { paddingTop: 10 }]}>
        <CloseIcon onPress={() => hideCard()} style={cardStyles.closeButton} />
        {/* Header */}
        <View style={cardStyles.header}>
          <View style={cardStyles.headerInfo}>
            <Text style={cardStyles.title}>Knowledge Base!</Text>
            <Text style={cardStyles.subTitle}>
              Tips & Tricks to drive healthy productivity
            </Text>
          </View>
        </View>

        <View style={styles.content}>
          {buttons.map((b, index) => (
            <TouchableOpacity
              onPress={() => openURL(b.url)}
              style={styles.row}
              key={index}
            >
              <View style={[styles.number]}>
                <Text style={styles.numberText}>{index + 1}</Text>
              </View>

              <Text style={[styles.tutorialText]}>{b.text}</Text>

              <Icons.ArrowRight
                fillColor={AppTheme.DEFAULT_COLOR}
                style={{
                  width: 22,
                  height: 22,
                }}
              />
            </TouchableOpacity>
          ))}
        </View>
        <TouchableOpacity
          style={{
            heigth: 24,
          }}
          onPress={seeMore}
        >
          <Text style={styles.more}>More resources</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  content: {
    width: "100%",
    display: "flex",
    paddingHorizontal: 6,
    marginTop: 16,
  },
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 14,
  },
  number: {
    width: 22,
    height: 22,
    borderRadius: 22,
    borderWidth: 1,
    borderColor: AppTheme.DEFAULT_COLOR,
    justifyContent: "center",
    alignItems: "center",
    marginRight: 8,
  },
  numberText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.DEFAULT_COLOR,
  },
  tutorialText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.DEFAULT_COLOR,
    marginLeft: 8,
  },
  more: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    opacity: 0.5,
    textAlign: "center",
  },
});
